/* eslint no-shadow: 0 */
// eslint-disable-next-line object-curly-newline
import {
  SETUP,
  SET_TOKEN,
  AUTH_REQUEST,
  AUTH_ERROR,
  AUTH_SUCCESS,
  AUTH_LOGOUT,
  CLEAR_REDIRECT_PATH,
  REDIRECT_PATH,
} from '@/store/actions/auth';

const SAVE_EMAIL = 'SAVE_EMAIL';

//   const APP = 'HSA';
//   const USER_TOKEN_KEY = `${APP}:access-token`;

const state = {
  // token: localStorage.getItem(USER_TOKEN_KEY) || '',
  system: '',
  env: '',
  token: '',
  payload: null,
};

const getters = {
  accessToken: (state) => state.token,
  payload: (state) => state.payload,
  system: (state) => state.system,
};

const actions = {
  // [AUTH_REQUEST]: ({ commit }, redirectPath) => {
  //   commit(AUTH_REQUEST, redirectPath);
  //   Auth.signIn(redirectPath);
  // },
  [SETUP]({ commit }, { system }) {
    commit(SETUP, system);
  },
  [SET_TOKEN]: ({ commit }, { token, payload }) => {
    console.log('actions SET_TOKEN', { token, payload });
    commit(SET_TOKEN, { token, payload });
  },
  [AUTH_LOGOUT]: ({ commit }) => {
    commit(AUTH_LOGOUT);
    // Auth.signOut();
  },
  [CLEAR_REDIRECT_PATH]: ({ commit }) => {
    commit(CLEAR_REDIRECT_PATH);
  },
};

const mutations = {
  [SETUP]: (state, system) => {
    console.log('process.env.NODE_ENV', process.env.NODE_ENV);
    console.log('system', system);
    
    // if (process.env.NODE_ENV === 'production') {
    //   state.system = system === 'lpa' ? 'lpa' : 'hsa';
    // } else {
    //   state.system = system === 'lpa' ? 'lpa-dev' : 'hsa-dev';
    // }

    state.system = system === 'lpa' ? 'lpa' : 'hsa';

    if (localStorage.getItem('vendor_app')) {
      const storeData = JSON.parse(localStorage.getItem('vendor_app'));
      storeData.system = state.system;

      localStorage.setItem('vendor_app', JSON.stringify(
        storeData
      ));
    } else {
      const storeData = {
        system: state.system
      };
      localStorage.setItem('vendor_app', JSON.stringify(
        storeData
      ));
    }
  },
  [SET_TOKEN]: (state, { token, payload }) => {
    console.log('mutations SET_TOKEN', { token, payload });
    state.token = token;
    state.payload = payload;

    const storeData = JSON.parse(localStorage.getItem('vendor_app'));
    storeData.token = token;
    storeData.payload = payload;

    localStorage.setItem('vendor_app', JSON.stringify(
      storeData
    ));

    console.log(state);
  },
  [AUTH_REQUEST]: (state, redirectPath) => {
    state.status = 'loading';
    localStorage[REDIRECT_PATH] = redirectPath;
  },
  [AUTH_SUCCESS]: (state, resp) => {
    state.status = 'success';
    state.token = resp.access_token;
    state.refreshToken = resp.refresh_token;
    state.hasLoadedOnce = true;
  },
  [AUTH_ERROR]: (state) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
  },
  [AUTH_LOGOUT]: (state) => {
    state.token = '';
  },
  [SAVE_EMAIL]: (state, email) => {
    state.email = email;
  },
  [CLEAR_REDIRECT_PATH]: () => {
    localStorage.removeItem(REDIRECT_PATH);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
